

import Vue from 'vue';
import App from './App';
import router from './router';
import tool from './js/tool.js';
import utils from './js/utils.js';
import './css/common.css';
import Vconsole from 'vconsole';

import 'lib-flexible/flexible';

import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin);

import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin);

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin);

import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)

import XHeader from 'vux/src/components/x-header/index.vue'

Vue.component('x-header', XHeader);
Vue.config.productionTip = false;
Vue.prototype.tool = tool;
Vue.prototype.utils = utils;

(Vue.prototype.alert = function(text) {
this.$vux.alert.show({
title: '提示',
content: text
});
}),
(Vue.prototype.loading = function(text) {
if (!text) {
text = "Loading"
}
this.$vux.loading.show({
text: 'Loading'
})
}),
(Vue.prototype.loadingClose = function() {
this.$vux.loading.hide()
}),
(Vue.prototype.toast = function(text, type, width) {
this.$vux.toast.show({
text,
type: type ? type : 'text', //可选值 success, warn, cancel, text
width: width ? width : '12em',
position: 'middle'
});
}); //初始化埋点工具类

if (!process.env.onLine) {
new Vconsole();
}else{

}
















/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js